import { useMemo } from 'react';

import { AssetClass } from '__generated__/globalTypes';
import { useGetPoolsList } from '../CashFlowModeling/getListingsList_gql';

interface Props {
  assetClass: AssetClass | null;
}
export const usePoolOptions = ({ assetClass }: Props) => {
  const { data: poolsList } = useGetPoolsList();

  const poolOptions = useMemo(() => {
    return poolsList?.user.company.pools
      ?.filter((listing) => listing.asset_class === assetClass)
      ?.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        return nameA.localeCompare(nameB);
      })
      ?.map((listing) => ({
        label: listing.name,
        value: listing.id,
        poolData: listing,
      }));
  }, [poolsList?.user.company.pools, assetClass]);

  return {
    poolOptions,
  };
};
